export default {
  'custom.lists.title': 'Lists',
  'custom.lists.button.open': 'Open',
  'custom.lists.tab.groups': 'Groups',
  'custom.lists.tab.favorites': 'Favorites',
  'custom.lists.text.created': 'The item has been created successfully.',
  'custom.lists.text.removed': 'The item has been removed successfully.',
  'custom.lists.text.edited': 'The item has been updated successfully.',
  'custom.lists.text.listGroups': 'List Groups',
  'custom.lists.text.listEntityGroups': 'Dynamic Entity Groups',

  'custom.lists.text.type': 'Type',
  'custom.lists.text.cliente': 'Client',
  'custom.lists.text.direccion': 'Address',
  'custom.lists.text.distrito': 'District',
  'custom.lists.text.completed': 'Completed',

  'customList.text.detail': 'Details',
  'customList.text.add': 'Add List',
  'customList.text.cancel': 'Cancel',
  'customList.text.void': 'Void',
  'customList.form.dataOrigin': 'Data origin',
  'customList.form.dataOrigin.process': 'Process',
  'customList.form.dataOrigin.dynamicEntity': 'Dynamic entity',
  'customList.form.processId.related': 'Related process (optional)',
  'customList.form.dynamicEntityId': 'Dynamic entity',
  // Shared with list-builder (create-list drawer is outside that route pack).
  'listBuilder.drawer.formMode.inline': 'Inline editing',
  'listBuilder.drawer.formMode.popup': 'Form editing',
  'customList.text.complete': 'Complete',
  'customList.text.approve': 'Approve',
  'customList.text.reject': 'Reject',
  'customList.text.execute': 'Execute',
  'customList.text.sign': 'Sign',
  'customList.text.reassign': 'Reassign',

  'custom.lists.text.message.cancel': 'The item has been canceled successfully',
  'custom.lists.text.message.void': 'The item has been voided successfully',
  'custom.lists.text.message.approve': 'The item has been approved successfully',
  'custom.lists.text.message.reject': 'The item has been rejected successfully',
  'custom.lists.text.message.complete': 'The item has been completed successfully',
  'custom.lists.text.message.execute': 'The item has been executed successfully',
  'custom.lists.text.message.sign': 'The item has been signed successfully',
  'custom.lists.text.message.reassign': 'The item has been reassigned successfully',

  'customList.listTaskTrace.title': 'Tasks traces',
  'customList.listTaskTrace.field.taskOutput': 'Task output',
  'customList.listTaskTrace.field.timeZone': 'Time zone',
  'customList.listTaskTrace.operationType.export': 'Export',
  'customList.listTaskTrace.operationType.unknown': 'Unknown',

  // ────────────────────────────────────────────────────────────────────
  // Modern Custom Lists view (`/custom-lists/view`)
  // ────────────────────────────────────────────────────────────────────
  'custom.lists.modern.refresh': 'Refresh',
  'custom.lists.modern.configure': 'Configure',
  'custom.lists.modern.tagline.fallback':
    'Browse, filter and act on your items with contextual commands.',

  'custom.lists.modern.eyebrow.list': 'LIST',
  'custom.lists.modern.eyebrow.cards': 'CARDS',
  'custom.lists.modern.eyebrow.map': 'MAP',
  'custom.lists.modern.eyebrow.tasks': 'TASKS',

  'custom.lists.modern.filters.toggle': 'Filters',
  'custom.lists.modern.filters.dynamicHeader': 'List filters',
  'custom.lists.modern.filters.clearAll': 'Clear all',

  'custom.lists.modern.group.back': 'Back to groups',
  'custom.lists.modern.group.itemsLabel': 'items',

  'custom.lists.modern.empty.title': 'No results',
  'custom.lists.modern.empty.description':
    "We couldn't find any items matching your current filters. Adjust the filters or create a new one if you have the right permissions.",

  'custom.lists.modern.bulk.selectFirst': 'Select at least one row to continue.',

  'custom.lists.modern.cards.moreActions': 'More actions',

  'custom.lists.modern.board.untitled': 'Untitled',
  'custom.lists.modern.board.columnEmpty': 'No items',
  'custom.lists.modern.board.noColumns': 'This list has no columns configured.',
  'custom.lists.modern.board.deadlineTooltip': 'Due date: {date}',
  'custom.lists.modern.board.commentsTooltip':
    '{count, plural, one {# comment} other {# comments}} · Open comments',
  'global.text.unassigned': 'Unassigned',

  'customList.select.taskBoard': 'Task Board',
  'customList.select.cardsList': 'Cards',
  'customList.select.mapList': 'Map',

  // Shared with applications-modern (declared locally to guarantee they
  // are available when this view loads without the Solicitudes module).
  'global.text.from': 'From',
  'global.text.to': 'To',
  'global.text.more': 'More',
  'global.button.remove': 'Remove',
};
